import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { AppSettingsService } from './app-settings.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class RegistrationService {

  private apiEndpoint;

  constructor(private http: HttpClient, private notificationService: NotificationsService, private AppSettings: AppSettingsService, private authService: AuthService) {
    this.apiEndpoint = this.AppSettings.getConfig('API_ENDPOINT');
  }

  getRegisteredPlayersByUser(userName): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'Player/GetRegisteredPlayersByUser/' + userName).map(response => {
      return response;
    });
  }

  getTop10RegisteredPlayersByUser(userName): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'Player/GetTop10RegisteredPlayersByUser/' + userName).map(response => {
      return response;
    });
  }

  registerPlayer(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'player/register', data).map(response => {
      return response;
    });
  }

  updatePlayer(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'player/update', data).map(response => {
      return response;
    });
  }

  deletePlayer(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'player/delete', data).map(response => {
      return response;
    });
  }

  getPlayerStatusObjectByUser(userName): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'Player/getPlayerStatusObjectByUser/' + userName).map(response => {
      return response;
    });
  }

  playerAction(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'player/action', data).map(response => {
      return response;
    });
  }

  dmbTVAction(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'player/dmbTVAction', data).map(response => {
      return response;
    });
  }

  getPlayerScreenshotTime(registrationCode): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'Player/getPlayerScreenshotTime/' + registrationCode).map(response => {
      return response;
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/Registration.service.ts